var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSquare84ASelected = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 62 62",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  stroke: "#C1A36E",
  strokeWidth: 2,
  d: "M18 19.5a1.5 1.5 0 0 1 1.5-1.5h23a1.5 1.5 0 0 1 1.5 1.5v23a1.5 1.5 0 0 1-1.5 1.5h-23a1.5 1.5 0 0 1-1.5-1.5v-23Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M3 28V18l8.274-.752A2.5 2.5 0 0 1 14 19.738v6.524a2.5 2.5 0 0 1-2.726 2.49L3 28Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#C1A36E",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m5 29-.445-.223A2.813 2.813 0 0 1 3 26.262v-6.524c0-1.065.602-2.039 1.555-2.515L5 17"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M3 44V34l8.274-.752A2.5 2.5 0 0 1 14 35.738v6.524a2.5 2.5 0 0 1-2.726 2.49L3 44Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  stroke: "#C1A36E",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m5 45-.445-.223A2.813 2.813 0 0 1 3 42.262v-6.524c0-1.065.602-2.039 1.555-2.515L5 33"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M59 18v10l-8.274.752A2.5 2.5 0 0 1 48 26.262v-6.524a2.5 2.5 0 0 1 2.726-2.49L59 18Z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  stroke: "#C1A36E",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m57 17 .445.223A2.813 2.813 0 0 1 59 19.738v6.524c0 1.065-.602 2.039-1.555 2.515L57 29"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M59 34v10l-8.274.752A2.5 2.5 0 0 1 48 42.262v-6.524a2.5 2.5 0 0 1 2.726-2.49L59 34Z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  stroke: "#C1A36E",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m57 33 .445.223A2.813 2.813 0 0 1 59 35.738v6.524c0 1.065-.602 2.039-1.555 2.515L57 45"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M18 3h10l.752 8.274A2.5 2.5 0 0 1 26.262 14h-6.524a2.5 2.5 0 0 1-2.49-2.726L18 3Z"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  stroke: "#C1A36E",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m17 5 .223-.445A2.813 2.813 0 0 1 19.738 3h6.524c1.065 0 2.039.602 2.515 1.555L29 5"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M34 3h10l.752 8.274A2.5 2.5 0 0 1 42.262 14h-6.524a2.5 2.5 0 0 1-2.49-2.726L34 3Z"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  stroke: "#C1A36E",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m33 5 .223-.445A2.813 2.813 0 0 1 35.738 3h6.524c1.065 0 2.039.602 2.515 1.555L45 5"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M28 59H18l-.752-8.274A2.5 2.5 0 0 1 19.738 48h6.524a2.5 2.5 0 0 1 2.49 2.726L28 59Z"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  stroke: "#C1A36E",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m29 57-.223.445A2.813 2.813 0 0 1 26.262 59h-6.524a2.813 2.813 0 0 1-2.515-1.555L17 57"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M44 59H34l-.752-8.274A2.5 2.5 0 0 1 35.738 48h6.524a2.5 2.5 0 0 1 2.49 2.726L44 59Z"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  stroke: "#C1A36E",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m45 57-.223.445A2.813 2.813 0 0 1 42.262 59h-6.524a2.813 2.813 0 0 1-2.515-1.555L33 57"
})));
SvgSquare84ASelected.viewBox = '0 0 62 62';
const ForwardRef = /*#__PURE__*/forwardRef(SvgSquare84ASelected);
export default ForwardRef;